import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { painCosts } from '../data/includes';
export function PainPoints() {
  return <section className="py-24 px-4 bg-stone-50" data-id="element-169" data-mp="2lp556r9nb2to">
      <div className="max-w-3xl mx-auto" data-id="element-170" data-mp="26xeftbjvgl3v">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-171" data-mp="26wboj2in0gnf">
          <p className="text-rose-700 font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-172" data-mp="1o1eidl84kpcw">
            A Teaching Day That Feels Too Familiar
          </p>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-stone-800" data-id="element-173" data-mp="3idbi01gq11j1">
            Does this sound familiar?
          </h2>
          <div className="text-lg text-stone-600 leading-relaxed bg-white p-6 rounded-2xl border border-stone-200 text-left space-y-4" data-id="element-174" data-mp="3nbwfvu8i394b">
            <p data-id="element-175" data-mp="1u1txcpuxycfa">
              Your next makeup class is coming up. And you're still thinking
              about what you're going to teach.
            </p>
            <p data-id="element-176" data-mp="27s76gvjkjx67">
              Which technique should come next? How should you explain it? What
              should you demonstrate first? What activity should your students
              practice? What mistakes should you expect? How should you correct
              them? And how do you know whether your students are actually
              progressing?
            </p>
            <p data-id="element-177" data-mp="1p3k0matkj3rk">
              <span className="text-rose-700 font-medium" data-id="element-178" data-mp="1p426lz618wco">
                Not because you don't know makeup.
              </span>{' '}
              You already know makeup. The problem is that knowing how to apply
              makeup is not the same as having a complete professional system
              for teaching it clearly, progressively and consistently.
            </p>
            <p data-id="element-179" data-mp="1t43p5aa78t0i">
              So you keep searching for ideas. Saving tutorials. Creating
              exercises. Preparing demonstrations. Building assessments. And
              organizing every lesson from scratch.
            </p>
            <p data-id="element-180" data-mp="223qozrna5qrg">Over time, that costs you much more than preparation time.</p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="space-y-6" data-id="element-181" data-mp="272k41oi7tptq">
          <h3 className="text-xl font-bold text-stone-800 mb-8 text-center" data-id="element-182" data-mp="1o7db0shyg7hq">
            The Real Cost of Not Having the Right Teaching System
          </h3>

          <ul className="space-y-3" data-id="element-183" data-mp="vozm5ieljvus">
            {painCosts.map((point, i) => <motion.li key={point} initial={{
            opacity: 0,
            x: -16
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: Math.min(i, 5) * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex items-start gap-4 bg-stone-100 p-4 rounded-xl border border-stone-200" data-id="element-184" data-mp="o6rycnkqg21p" data-mpi={i}>
                <X size={18} className="text-rose-800 shrink-0 mt-0.5" aria-hidden="true" data-id="element-185" data-mp="3rnqn3az4cemi" />
                <span className="text-stone-600" data-id="element-186" data-mp="3im0ui1ti39n5">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-stone-200" data-id="element-187" data-mp="3dmxpghdit3f6">
            <p className="text-2xl font-serif font-bold text-rose-900" data-id="element-188" data-mp="1hkb4ssap8jrb">
              Stop giving away your preparation time. Your professional
              knowledge is already there. What you need now is the right
              teaching system behind it.
            </p>
            <p className="text-xl mt-4 text-stone-800" data-id="element-189" data-mp="17s5a3at2bo8f">
              Start your next teaching week with your classes already
              structured.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}